<template>
  <input type="number" class="stepper-typer" ref="numberInput" v-ios-bug-fixed :value="currentValue" @input="onInput" @focus="onFocus" @blur="onBlur" name="">
</template>

<script type="text/javascript">
  export default {
    props: {
      value: {
        default: 1
      },
      min: {
        default: 0
      },
      max: {
        default: Infinity
      },
      integer: Boolean,
    },
    data() {
      const value = this.range(this.isDef(this.value) ? this.value : this.defaultValue);
      if (value !== +this.value) {
        this.$emit('input', value);
      }
      return {
        currentValue: value
      }
    },
    watch: {
      value(val) {
        if (val !== this.currentValue) {
          this.currentValue = this.format(val);
        }
      },
      currentValue(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      }
    },
    // mounted() {
    //   window.addEventListener('focusout', this.fixScrollTop);
    // },
    // beforeDestory() {
    //   window.removeEventListener('focusout', this.fixScrollTop);
    // },
    methods: {
      isDef(value) {
        return value !== undefined && value !== null;
      },
      format(value) {
        value = String(value).replace(/[^0-9.-]/g, '');
        return value === '' ? 0 : this.integer ? Math.floor(value) : +value;
      },
      onInput(event) {
        const { value } = event.target;
        const formatted = this.format(value);

        if (+value !== formatted) {
          event.target.value = formatted;
        }
        this.currentValue = formatted;
      },
      onFocus() {
        this.$emit('focus', event);
      },
      onBlur(event) {
        this.currentValue = this.range(this.currentValue);
        this.$emit('blur', event);

        if (this.currentValue === 0) {
          event.target.value = this.currentValue;
        }
      },
      range(value) {
        return Math.max(Math.min(this.max, this.format(value)), this.min);
      },
      focus() {
        this.$refs.numberInput.focus();
      }
      // fixScrollTop() {
      //   setTimeout(() => {
      //     document.body.scrollTop = document.body.scrollTop
      //     console.log(document.body.scrollHeight)
      //   }, 100)
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/numberInput.vue